import { Filesystem, Directory } from '@capacitor/filesystem';
import { Capacitor } from '@capacitor/core';
import toast from 'react-hot-toast';
import { MESSAGES } from "../constants";

export const downloadFile = async (fileUrl) => {
  try {
    const parts = fileUrl.split("/");
    const fileName = parts[parts.length - 1];
    const response = await fetch(fileUrl);
    if (!response.ok) throw new Error(MESSAGES.FAIL_TO_FETCH_FILE);

    const blob = await response.blob();

    const isMobile = Capacitor.getPlatform() !== 'web';

    if (isMobile) {
      // Convert blob to base64
      const base64Data = await blobToBase64(blob);
      try {
        await Filesystem.writeFile({
          path: fileName,
          data: base64Data,
          directory: Directory.Documents
        });
      } catch (e) {
        toast.error(MESSAGES.MOBILE_WRITE_FAIL);
        await Filesystem.writeFile({
          path: fileName,
          data: base64Data,
          directory: Directory.ExternalStorage,
          recursive: true
        });
      }

    } else {
      // Web: trigger download using anchor tag
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }
  } catch (err) {
    throw new Error(MESSAGES.FAIL_TO_FETCH_FILE);
  }
};

// Helper function to convert blob to base64
const blobToBase64 = (blob) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = reject;
    reader.onload = () => {
      const base64 = reader.result.split(',')[1];
      resolve(base64);
    };
    reader.readAsDataURL(blob);
  });
